import { loadGSAP } from './gsap.js';

export async function loadScrollTrigger() {
  await loadGSAP();
  await window.siteLoadOnce(
    'https://cdn.jsdelivr.net/npm/gsap@3.14.2/dist/ScrollTrigger.min.js'
  );
  window.gsap.registerPlugin(window.ScrollTrigger);
}
